import { getRequirementsErrorMessage } from '@/helpers/requirementErrors'

/**
 * Explains a disabled Confirm button. Without it the button reads as inert: the handler bails on
 * `!transaction || !client`, and neither state has any other user-visible surface.
 */
export function getReviewErrorReason({
  blockedReason,
  isTransactionMissing,
  isWalletClientMissing,
  requirementsError
}: {
  /** The refreshed panel logic rejects the reviewed request (e.g. the position dropped). */
  blockedReason?: string
  /** The bundle never resolved and nothing is in flight. */
  isTransactionMissing: boolean
  /** `useWalletClient()` settled with no client (e.g. a WalletConnect session that never linked). */
  isWalletClientMissing: boolean
  /** Requirements could not be resolved for the current withdrawal inputs. */
  requirementsError?: Error | null
}): string | undefined {
  if (blockedReason) return blockedReason
  if (requirementsError) return getRequirementsErrorMessage(requirementsError)
  if (isWalletClientMissing) {
    return 'Wallet connection unavailable. Reconnect your wallet and try again.'
  }
  if (isTransactionMissing)
    return "This transaction can't be prepared right now. Close this review and try again."
  return undefined
}
